import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function resetBusCounterError(option) {
    return (
        <FormattedMessage id="controller.history.options.resetBusCounterError.bus" values={{ bus: option.bus + 1 }} />
    );
}
